import { Authenticated, UnAuthenticated } from "components/Guard";
import { GuardedRoute } from "components/PermissionGuards";
import MainLayout from "components/MainLayout";
import AreaPage from "pages/Areas";
import CategoryPage from "pages/Categories";
import ClientPage from "pages/Clients";
import CodesPage from "pages/Codes";
import ComplaintPage from "pages/Complaints";
import DashboardPage from "pages/Dashboard";
import DealerPage from "pages/Dealers";
import ErrorPage from "pages/Error";
import ForgotPasswordPage from "pages/ForgotPassword";
import InstitutionPage from "pages/Institutions";
import LoginPage from "pages/Login";
import LogPage from "pages/Logs";
import ManageAreaPage from "pages/ManageArea";
import ManageCategoryPage from "pages/ManageCategory";
import ManageClientPage from "pages/ManageClient";
import ManageDealerPage from "pages/ManageDealer";
import ManageInstitutionPage from "pages/ManageInstitution";
import ManageLoadDataPage from "pages/ManageLoadData";
import ManageMemberPage from "pages/ManageMember";
import ManageProductPage from "pages/ManageProduct";
import ManageQrCodePage from "pages/ManageQrCode";
import ManageMemberQrCodePage from "pages/ManageQrCode/memberQrRequest";
import ManageRolePage from "pages/ManageRole";
import ManageTaxPayerPage from "pages/ManagerTaxPayer";
import ManageSubAreaPage from "pages/ManageSubArea";
import ManageSubCategoryPage from "pages/ManageSubCategory";
import ManageTaxAssessmentPage from "pages/ManageTaxAssessment";
import ManageTaxCollectorPage from "pages/ManageTaxCollector";
import ManageTaxFrequencyPage from "pages/ManageTaxFrequency";
import ManageTaxNaturePage from "pages/ManageTaxNature";
import ManageTaxSupervisorPage from "pages/ManageTaxSupervisor";
import ManageTaxTypePage from "pages/ManageTaxType";
import ManageUserPage from "pages/ManageUser";
import MembersPage from "pages/Members";
import NotFound from "pages/NotFound";
import ProductPage from "pages/Products";
import ProfilePage from "pages/Profile";
import QrCodePage from "pages/QrCodes";
import RolePage from "pages/Roles";
import SetPasswordPage from "pages/SetPassword";
import ChangePasswordFirstLoginPage from "pages/ChangePasswordFirstLogin";
import SettingPage from "pages/Settings";
import SubAreaPage from "pages/SubAreas";
import SubCategoryPage from "pages/SubCategories";
import TaxAssessmentPage from "pages/TaxAssessments";
import TaxCollectorPage from "pages/TaxCollectors";
import TaxDashboardPage from "pages/TaxDashboard";
import TaxDataUploadPage from "pages/TaxDataUploads";
import TaxFrequencyPage from "pages/TaxFrequncies";
import TaxLogPage from "pages/TaxLogs";
import TaxNaturePage from "pages/TaxNature";
import TaxPayerPage from "pages/TaxPayers";
import TaxPaymentPage from "pages/TaxPayments";
import TaxSupervisorPage from "pages/TaxSupervisors";
import TaxTypePage from "pages/TaxTypes";
import TrackingDashboardPage from "pages/Tracking/TrackingDashboardPage";
import TrackingTripHistoryPage from "pages/Tracking/TrackingTripHistoryPage";
import TrackingTripLiveMapPage from "pages/Tracking/TrackingTripLiveMapPage";
import TrackingStudentsListPage from "pages/Tracking/TrackingStudentsListPage";
import TrackingStudentCreatePage from "pages/Tracking/TrackingStudentCreatePage";
import TrackingStudentsUploadPage from "pages/Tracking/TrackingStudentsUploadPage";
import TrackingProfilePage from "pages/Tracking/TrackingProfilePage";
import TrackingNotificationsPage from "pages/Tracking/TrackingNotificationsPage";
import TrackingAddressesPage from "pages/Tracking/TrackingAddressesPage";
import TrackingParentPage from "pages/Tracking/TrackingParentPage";
import TrackingStudentDetailPage from "pages/Tracking/TrackingStudentDetailPage";
import TrackingGuardDashboardPage from "pages/Tracking/TrackingGuardDashboardPage";
import TrackingGuardSitesPage from "pages/Tracking/TrackingGuardSitesPage";
import TrackingGuardShiftsPage from "pages/Tracking/TrackingGuardShiftsPage";
import TrackingGuardIncidentsPage from "pages/Tracking/TrackingGuardIncidentsPage";
import TrackingGuardDailyReportPage from "pages/Tracking/TrackingGuardDailyReportPage";
import TrackingParentPaymentsPage from "pages/Tracking/TrackingParentPaymentsPage";
import TrackingParentInvoicesPage from "pages/Tracking/TrackingParentInvoicesPage";
import TrackingEmptyListPage from "pages/Tracking/TrackingEmptyListPage";
import TrackingDriversPage from "pages/Tracking/TrackingDriversPage";
import TrackingParentsPage from "pages/Tracking/TrackingParentsPage";
import TrackingPaymentsPage from "pages/Tracking/TrackingPaymentsPage";
import TrackingBusPage from "pages/Tracking/TrackingBusPage";
import TrackingRoutesPage from "pages/Tracking/TrackingRoutesPage";
import TrackingStopsPage from "pages/Tracking/TrackingStopsPage";
import TrackingTripsListPage from "pages/Tracking/TrackingTripsListPage";
import {
  TrackingTripStudentsCanPage,
  TrackingTripStopsPage,
  TrackingTripPositionsPage,
  TrackingStudentPresencePage,
  TrackingPatrolsPage,
  TrackingIncidentMediaPage,
  TrackingGuardAgentsPage,
  TrackingPatrolChecksPage,
} from "pages/Tracking/TrackingAdminListPages";
import TrackingStudentUnavailabilityHistoryPage from "pages/Tracking/TrackingStudentUnavailabilityHistoryPage";
import {
  TrackingSLAConfigPage,
  TrackingGuardCompaniesPage,
  TrackingGuardPostsPage,
  TrackingIncidentTypesPage,
} from "pages/Tracking/TrackingAdminCRUDPages";
import { TRACKING_EMPTY_LIST_CONFIG } from "pages/Tracking/trackingEmptyListConfig";
import { UnauthorizedPage } from "pages/Unauthorized";
import UserPage from "pages/Users";
import { useRoutes } from "react-router-dom";
import { ADMIN, COMPANY, DEALER, TAX_ADMIN, TAX_COLLECTOR, TAX_PAYER, TAX_SUPER_ADMIN, TAX_SUPERVISOR } from "utils/roles";

const ProjectRoutes = () => {
  let element = useRoutes([
    { path: "/", element: <LoginPage /> },
    { path: "*", element: <NotFound /> },
    {
      path: "unauthorized",
      element: <UnauthorizedPage />,
    },
    {
      path: "login",
      element: (
        <UnAuthenticated>
          <LoginPage />
        </UnAuthenticated>
      ),
    },
    {
      path: "forgot-password",
      element: (
        <UnAuthenticated>
          <ForgotPasswordPage />
        </UnAuthenticated>
      ),
    },
    {
      path: "reset-password/:token",
      element: (
        <UnAuthenticated>
          <SetPasswordPage />
        </UnAuthenticated>
      ),
    },
    {
      path: "change-password-first-login",
      element: (
        <Authenticated>
          <ChangePasswordFirstLoginPage />
        </Authenticated>
      ),
    },
    {
      path: "tax/dashboard",
      element: (
        <Authenticated>
          <GuardedRoute requiredPermission="get taxdashboard">
            <TaxDashboardPage />
          </GuardedRoute>
        </Authenticated>
      ),
    },
    {
      path: "dashboard",
      element: (
        <Authenticated>
          <GuardedRoute requiredPermission="get dashboard">
            <DashboardPage />
          </GuardedRoute>
        </Authenticated>
      ),
    },
    {
      path: "tracking",
      element: <MainLayout />,
      children: [
        {
          path: "students",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermissions={["get tracking_students", "get eleve"]} requireAll={false}>
                <TrackingStudentsListPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "students/add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create tracking_student">
                <TrackingStudentCreatePage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "students/add/upload",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create tracking_student">
                <TrackingStudentsUploadPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get tracking_dashboard">
                <TrackingDashboardPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "trip/:tripId/history",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get tracking_trip_history">
                <TrackingTripHistoryPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "trip/:tripId/live",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get tracking_trip_history">
                <TrackingTripLiveMapPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "profile",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get tracking_profile">
                <TrackingProfilePage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "notifications",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermissions={["get tracking_notifications", "get notification"]} requireAll={false}>
                <TrackingNotificationsPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "addresses",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermissions={["get tracking_addresses", "get address"]} requireAll={false}>
                <TrackingAddressesPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "parent",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get tracking_parent">
                <TrackingParentPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "parent/students/:studentId",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get tracking_parent">
                <TrackingStudentDetailPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "parent/payments",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get tracking_parent_payments">
                <TrackingParentPaymentsPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "parent/invoices",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get tracking_parent_invoices">
                <TrackingParentInvoicesPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "guard",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get guard_dashboard">
                <TrackingGuardDashboardPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "guard/sites",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermissions={["get guard_sites", "get guardedsite"]} requireAll={false}>
                <TrackingGuardSitesPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "guard/shifts",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermissions={["get guard_shifts", "get guardshift"]} requireAll={false}>
                <TrackingGuardShiftsPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "guard/incidents",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermissions={["get guard_incidents", "get incident"]} requireAll={false}>
                <TrackingGuardIncidentsPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "guard/daily-report",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get guard_daily_report">
                <TrackingGuardDailyReportPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        /* Pages branchées sur l'API Tracking (drivers, parents, payments, bus, routes, stops) */
        { path: "drivers", element: <Authenticated><GuardedRoute requiredPermission="get driver"><TrackingDriversPage /></GuardedRoute></Authenticated> },
        { path: "parents", element: <Authenticated><GuardedRoute requiredPermission="get parent"><TrackingParentsPage /></GuardedRoute></Authenticated> },
        { path: "trips", element: <Authenticated><GuardedRoute requiredPermission="get trip"><TrackingTripsListPage /></GuardedRoute></Authenticated> },
        { path: "stops", element: <Authenticated><GuardedRoute requiredPermission="get stop"><TrackingStopsPage /></GuardedRoute></Authenticated> },
        { path: "trip-students-can", element: <Authenticated><GuardedRoute requiredPermission="get tripstudentscan"><TrackingTripStudentsCanPage /></GuardedRoute></Authenticated> },
        { path: "trip-stops", element: <Authenticated><GuardedRoute requiredPermission="get tripstop"><TrackingTripStopsPage /></GuardedRoute></Authenticated> },
        { path: "trip-positions", element: <Authenticated><GuardedRoute requiredPermission="get tripposition"><TrackingTripPositionsPage /></GuardedRoute></Authenticated> },
        { path: "student-presence", element: <Authenticated><GuardedRoute requiredPermission="get student_presence"><TrackingStudentPresencePage /></GuardedRoute></Authenticated> },
        { path: "student-unavailability-history", element: <Authenticated><GuardedRoute requiredPermission="get student_unavailability_history"><TrackingStudentUnavailabilityHistoryPage /></GuardedRoute></Authenticated> },
        { path: "payments", element: <Authenticated><GuardedRoute requiredPermission="get payment"><TrackingPaymentsPage /></GuardedRoute></Authenticated> },
        { path: "routes", element: <Authenticated><GuardedRoute requiredPermission="get route"><TrackingRoutesPage /></GuardedRoute></Authenticated> },
        { path: "bus", element: <Authenticated><GuardedRoute requiredPermission="get bus"><TrackingBusPage /></GuardedRoute></Authenticated> },
        { path: "patrols", element: <Authenticated><GuardedRoute requiredPermission="get patrol"><TrackingPatrolsPage /></GuardedRoute></Authenticated> },
        { path: "incident-media", element: <Authenticated><GuardedRoute requiredPermission="get incidentmedia"><TrackingIncidentMediaPage /></GuardedRoute></Authenticated> },
        { path: "sla-config", element: <Authenticated><GuardedRoute requiredPermission="get slaconfig"><TrackingSLAConfigPage /></GuardedRoute></Authenticated> },
        { path: "guard-agents", element: <Authenticated><GuardedRoute requiredPermission="get guardagent"><TrackingGuardAgentsPage /></GuardedRoute></Authenticated> },
        { path: "guard-posts", element: <Authenticated><GuardedRoute requiredPermission="get guardpost"><TrackingGuardPostsPage /></GuardedRoute></Authenticated> },
        { path: "guard-companies", element: <Authenticated><GuardedRoute requiredPermission="get guardcompany"><TrackingGuardCompaniesPage /></GuardedRoute></Authenticated> },
        { path: "patrol-checks", element: <Authenticated><GuardedRoute requiredPermission="get patrolcheck"><TrackingPatrolChecksPage /></GuardedRoute></Authenticated> },
        { path: "incident-types", element: <Authenticated><GuardedRoute requiredPermission="get incidenttype"><TrackingIncidentTypesPage /></GuardedRoute></Authenticated> },
      ],
    },
    {
      path: "clients",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get company">
                <ClientPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create company">
                <ManageClientPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update company">
                <ManageClientPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "products",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get product">
                <ProductPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create product">
                <ManageProductPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update product">
                <ManageProductPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "areas",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get area">
                <AreaPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create area">
                <ManageAreaPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update area">
                <ManageAreaPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "sub-areas",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get subarea">
                <SubAreaPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create subarea">
                <ManageSubAreaPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update subarea">
                <ManageSubAreaPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "institutions",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get institution">
                <InstitutionPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create institution">
                <ManageInstitutionPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update institution">
                <ManageInstitutionPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "tax-frequencies",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get taxfrequency">
                <TaxFrequencyPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create taxfrequency">
                <ManageTaxFrequencyPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update taxfrequency">
                <ManageTaxFrequencyPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "tax-types",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get taxtype">
                <TaxTypePage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create taxtype">
                <ManageTaxTypePage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update taxtype">
                <ManageTaxTypePage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "tax-payers",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get taxpayer">
                <TaxPayerPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create taxpayer">
                <ManageTaxPayerPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "add/upload",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create taxpayer">
                <ManageLoadDataPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update taxpayer">
                <ManageTaxPayerPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "tax-collectors",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get taxcollector">
                <TaxCollectorPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create taxcollector">
                <ManageTaxCollectorPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
                <GuardedRoute requiredPermission="update taxcollector">
                <ManageTaxCollectorPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "tax-supervisors",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get taxsupervisor">
                <TaxSupervisorPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create taxsupervisor">
                <ManageTaxSupervisorPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update taxsupervisor">
                <ManageTaxSupervisorPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "tax-assessments",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get taxassessment">
                <TaxAssessmentPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create taxassessment">
                <ManageTaxAssessmentPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update taxassessment">
                <ManageTaxAssessmentPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "tax-natures",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get taxnature">
                <TaxNaturePage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create taxnature">
                <ManageTaxNaturePage />
              </GuardedRoute>
            </Authenticated>
          )
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update taxnature">
                <ManageTaxNaturePage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "tax-payments",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get taxpayment">
                <TaxPaymentPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "tax/logs",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get taxlog">
                <TaxLogPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "tax/data-uploads",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get taxdataupload">
                <TaxDataUploadPage />
              </GuardedRoute>
            </Authenticated>
          )
        },
      ]
    },
    {
      path: "documents",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get member">
                <MembersPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create member">
                <ManageMemberPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "dealers",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get dealer">
                <DealerPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create dealer">
                <ManageDealerPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update dealer">
                <ManageDealerPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "categories",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get productcategory">
                <CategoryPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create productcategory">
                <ManageCategoryPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update productcategory">
                <ManageCategoryPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "sub-categories",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get subcategory">
                <SubCategoryPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create subcategory">
                <ManageSubCategoryPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update subcategory">
                <ManageSubCategoryPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "users",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get systemuser">
                <UserPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <ManageUserPage />
            </Authenticated>
          ),
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update systemuser">
                <ManageUserPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "roles",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get role">
                <RolePage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create role">
                <ManageRolePage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update role">
                <ManageRolePage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "qrcode-requests",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get qrcodes">
                <QrCodePage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "documents/add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create qrcodes">
                <ManageMemberQrCodePage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "add",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="create qrcodes">
                <ManageQrCodePage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
        {
          path: "edit/:id",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="update qrcodes">
                <ManageQrCodePage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "qrcodes/:requestId",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get qrcodes">
                <CodesPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "complaints",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get complaint">
                <ComplaintPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "settings",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get setting">
                <SettingPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "profile",
      element: <MainLayout />,
      children: [
        {
          path: "update",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get profile">
                <ProfilePage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
    {
      path: "logs",
      element: <MainLayout />,
      children: [
        {
          path: "",
          element: (
            <Authenticated>
              <GuardedRoute requiredPermission="get log">
                <LogPage />
              </GuardedRoute>
            </Authenticated>
          ),
        },
      ]
    },
  ]);

  return element;
};

export default ProjectRoutes;
